import React, { useState, useEffect, useRef } from 'react';
import './Navigation.css';
import { NavLink } from 'react-router-dom';
import { MdOutlineClose, MdOutlineMenu } from 'react-icons/md';
import {Logo} from '../../assets/icons/index'

function Navigation() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const navLinksRef = useRef(null);
    const hamburgerRef = useRef(null);

    const navLinks = [
        { name: 'HOME', path: '/' },
        { name: 'PORTFOLIO', path: '/portfolio' },
        { name: 'SERVICES', path: '/services' },
        { name: 'ABOUT US', path: '/about-us' },
        { name: 'GALLARY', path: '/gallery' },
        { name: 'CONTACT US', path: '/contact-us' },
        { name: 'AWARDS', path: '/awards' },
    ];

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const renderHamburgerIcon = () => {
        return isMenuOpen ? (
            <MdOutlineClose size="30px" color="black" />
        ) : (
            <MdOutlineMenu size="30px" color="black" />
        );
    };

    const renderNavLinks = () => {
    return navLinks.map((link) => (
        <li key={link.name} className='link-hover'>
            <NavLink 
                to={link.path} 
                onClick={() => setIsMenuOpen(false)} // Close menu on link click
            >
                {link.name}
            </NavLink>
        </li>
    ));
};


    useEffect(() => {
        const handleScroll = () => {
            if (isMenuOpen) {
                setIsMenuOpen(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [isMenuOpen]);

    useEffect(() => {
        if (isMenuOpen) {
            setTimeout(() => {
                navLinksRef.current.classList.add('show');
            }, 50);
        } else {
            if (navLinksRef.current) {
                navLinksRef.current.classList.remove('show');
            }
        }
    }, [isMenuOpen]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isMenuOpen && 
                !navLinksRef.current?.contains(event.target) && 
                !hamburgerRef.current?.contains(event.target)) {
                setIsMenuOpen(false);
            }
        };

        if (isMenuOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isMenuOpen]);

    return (
        <header className='main'>
            {/* <div className = "contact-container">
              <div className= "contact-information">
              <div className='contact-items'>
              <img width= {15} src="https://img.icons8.com/ios-filled/50/FFFFFF/phone.png" alt="phone"/>
              <p>+91 6353 886 588</p>
              </div>
              <div className = "contact-items">
              <img width= {15} className = "icons-img" src="https://img.icons8.com/ios-filled/50/FFFFFF/new-post.png" alt="new-post" color='white'/>
              <p><a href="mailto:shreedattguru03@gmai.com">shreedattguru03@gmai.com</a></p>
              
              </div>   
              </div>
              </div> */}
            <nav className="main-nav">
                <div className="logo-element">
                    <img alt="" className = "icons-img !h-[107px] !w-[190px]" src={Logo} width="150px"  />
                </div>
                <div className='nav-elements'>
                    <button 
                        className="hamburger" 
                        ref={hamburgerRef} 
                        onClick={toggleMenu}
                    >
                        {renderHamburgerIcon()}
                    </button>
                    <ul
                        className={`nav-links ${isMenuOpen ? 'open' : ''}`}
                        ref={navLinksRef}
                    >
                        {renderNavLinks()}
                    </ul>
                </div>
            </nav>
        </header>
    );
}

export default Navigation;
